import globalActionConstants from '../constants/globalActionConstants';

const initialState = {
  loading: false,
};

const globalReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case globalActionConstants.SET_LOADING_ON:
      return {
        ...state,
        loading: true,
      };
    case globalActionConstants.SET_LOADING_OFF:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
};

export default globalReducer;
